// CalendarPreview.js
import { useState } from 'react';
import CalendarSlideshow from './CalendarSlideshow';
import PurchaseFormModal from './PurchaseFormModal';

function CalendarPreview() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const originalPrice = 699;
  const discountedPrice = 499;
  const isSoldOut = true; // New state to control sold out status

  return (
    <>
      <div className="mt-3 sm:mt-4 md:mt-6 mb-8 sm:mb-12 md:mb-20">
        <div className="relative p-6 sm:p-8 md:p-12 lg:p-16 bg-gradient-to-br from-[#f8f8f8] via-[#f0f0f0] to-[#e8f0f0] rounded-[24px] md:rounded-[32px]">
          <div className="flex flex-col md:flex-row items-start gap-8 md:gap-12">
            {/* Content Section */}
            <div className="flex-1">
              <div className="flex flex-col sm:flex-row items-center md:items-start gap-2 mb-4 md:mb-6">
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-fraunces leading-[1.1] tracking-tighter text-center md:text-left">
                  2025 Calendar
                </h2>
                {isSoldOut && (
                  <span className="bg-red-500 text-white px-4 py-2 rounded-full text-sm font-medium">
                    Sold Out
                  </span>
                )}
              </div>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed tracking-tight mb-6 md:mb-8 text-center md:text-left mx-auto md:mx-0 max-w-[95%] md:max-w-[90%]">
                This calendar is a heartfelt journey through childhood memories and simple joys. From the warmth of a bonfire to the whimsy of spinning tops and the joy of building pillow forts, each month brings moments that rekindle forgotten happiness, refill your spirit with positivity, and inspire reflection. 
                These illustrations invites you to cherish old memories, find beauty in small things, and embrace new beginnings with warmth, hope and gratitude.
              </p>

              {/* Price Section */}
              <div className="mb-4 md:mb-6 flex flex-col items-center md:items-start">
                <div className="flex items-baseline gap-3 mb-1">
                  <span className="text-2xl md:text-3xl font-fraunces">₹{discountedPrice}</span>
                  <span className="text-base md:text-lg text-gray-500 line-through">₹{originalPrice}</span>
                  <span className="text-green-600 text-sm">
                    ({Math.round(((originalPrice - discountedPrice) / originalPrice) * 100)}% off)
                  </span>
                </div>
                <span className="text-sm text-gray-600">Inclusive of delivery across India</span>
              </div>

              <div className="flex flex-col sm:flex-row gap-3 md:gap-4 w-full sm:w-auto">
                <button
                  disabled={isSoldOut}
                  onClick={() => !isSoldOut && setIsModalOpen(true)}
                  className={`w-full sm:w-auto inline-flex items-center justify-center px-6 md:px-8 py-3 rounded-full transition-colors duration-300 text-base md:text-lg
                    ${isSoldOut 
                      ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                      : 'bg-black text-white hover:bg-gray-800'
                    }`}
                >
                  {isSoldOut ? 'Sold Out' : 'Purchase Now'}
                </button>
              </div>
            </div>

            {/* Calendar Section */}
            <div className="w-full md:w-1/2 rounded-2xl overflow-hidden mt-6 md:mt-0">
              <CalendarSlideshow
                showControls={true}
                mobileControls={true}
              />
            </div>
          </div>
        </div>
      </div>

      <PurchaseFormModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        price={discountedPrice}
      />
    </>
  );
}

export default CalendarPreview;